import { CommonKeys } from "../../common/enums";
import { FORMULAR_GROUP_STAMM_TYPE, STAMM_ELEMENTE_TYPE } from "../../common/formular-group-types";
import { FormularGroupStammStammElementBaseSchema } from "./stammelements/StammElement";
import { FormularGroupStammStammElementAnlageSchema } from "./stammelements/StammElementAnlage";
import { FormularGroupStammStammElementBelegSchema } from "./stammelements/StammElementBeleg";
import { FormularGroupStammStammElementDynFieldSchema } from "./stammelements/StammElementDynField";
import { FormularGroupStammStammElementMetaSchema } from "./stammelements/StammElementMeta";
import { FormularGroupStammStammElementTaskSchema } from "./stammelements/StammElementTask";
import { FormularGroupStammStammElementVertragSchema } from "./stammelements/StammElementVertrag";

const FormularGroupStammSchema = {
    $id: "FormularGroupStammSchema",
    title: "FormularGroupStamm Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_STAMM_TYPE },
        StammElemente: { $ref: "FormularGroupStammStammElementeSchema" },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
        [CommonKeys.ShowLabel]: { type: "boolean" }
    },
    required: [CommonKeys.Type, "StammElemente", CommonKeys.ID, CommonKeys.Label, CommonKeys.ShowLabel],
    additionalProperties: false
}

const FormularGroupStammStammElementeSchema = {
    $id: "FormularGroupStammStammElementeSchema",
    title: "StammElemente Schema for FormularGroupStamm Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: STAMM_ELEMENTE_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: {
                oneOf: [
                    { $ref: "FormularGroupStammStammElementAnlageSchema" },
                    { $ref: "FormularGroupStammStammElementBelegSchema" },
                    { $ref: "FormularGroupStammStammElementDynFieldSchema" },
                    { $ref: "FormularGroupStammStammElementMetaSchema" },
                    { $ref: "FormularGroupStammStammElementTaskSchema" },
                    { $ref: "FormularGroupStammStammElementVertragSchema" },
                ]
            }
        },
    },
    required: [CommonKeys.Type, CommonKeys.Values]
}

export const FORMULAR_GROUP_STAMM_SCHEMAS = [
    FormularGroupStammSchema,
    FormularGroupStammStammElementeSchema,
    FormularGroupStammStammElementBaseSchema,
    FormularGroupStammStammElementAnlageSchema,
    FormularGroupStammStammElementBelegSchema,
    FormularGroupStammStammElementDynFieldSchema,
    FormularGroupStammStammElementMetaSchema,
    FormularGroupStammStammElementTaskSchema,
    FormularGroupStammStammElementVertragSchema
]